<template>
  <div>
    <div class="row" v-for="record in records" :key="record.skill">
      <div class="input-field recordInput">
        <span>Your known {{record.name}}</span>
        <InputRecord :record="record" :isReadOnly="false" />
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import InputRecord from '@/components/records/InputRecord'
export default {
  name: 'initRecords',
  components: { InputRecord },
  data: function () {
    return {
      user: undefined,
      records: []
    }
  },
  created () {
    this.user = api.getCurrentUser()
    // get the list of skills marked as init==true
    const skills = api.getSkills()
    const selectedSkillNames = Object.keys(skills).filter(skill => skills[skill].init)
    // add the skill to the user records
    var records = []
    selectedSkillNames.forEach(function (skillName) {
      var record = skills[skillName]
      record.skill = skillName
      records.push(record)
    })
    this.records = records
  },
  mounted () {
  },
  watch: {
    records: {
      deep: true,
      handler () {
        var toUpdate = false
        for (var i in this.records) {
          const record = this.records[i]
          if (record.value || record.valueMinutes || record.valueSeconds) {
            this.user.addRecord(record)
            toUpdate = true
          }
        }
        // update user records and set the user initialized
        if (toUpdate) {
          this.user.athlete.recordsInit = true
          api.update(this.user)
        }
      }
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/records/InitRecords.vue